import _property from 'lodash/property';
export var getSelectedTypeFromValue = _property('type');
export var getSelectedOperatorFromValue = _property('operator');
export var getOperatorOptionLabel = _property('name');
export var getOperatorOptionValue = _property('id');